const webpFileMatch = /\.webp$/;
const webpToPng = (imgSrc: string): string => imgSrc?.replace(webpFileMatch, '.png');

export default function webpWithPngFallback(
  imgSrc: string,
  isWebPSupported: boolean = true
): string {
  return isWebPSupported ? imgSrc : webpToPng(imgSrc);
}
